import React, { Component } from "react";
import { Glyphicon, Grid, Row, Col, Modal, Button } from "react-bootstrap";
import ContactForm from './ContactForm';
import './Contact.css';

export default class Contact extends Component {
  constructor(props) {
  	super(props);
  	this.state = {
      show: false
  	};
  }

  handleClickMap = (evt) => {
    evt.preventDefault();
    this.setState({show: true});
  }

  handleCloseMap = () => {
    this.setState({show: false});
  }

  render() {
    return (
      <div className="Contact">
        <Grid>
          <h3 className="title">Contacto</h3>
          <Row>
            <Col md={6}>
              <div>
                <h3>Vis&iacute;tanos</h3>
                <p>
                  <Glyphicon glyph='map-marker' /> <a href="#address" onClick={this.handleClickMap}>Av. del Valle #601 OF. 51, Ciudad Empresarial, Huechuraba, Región Metropolitana</a>
                </p>
              </div>
              <hr/>
              <div>
                <h3>Ll&aacute;manos</h3>
                <p>
                  <Glyphicon glyph='phone' /> <a href="tel:+56222336059">+56 2 2233 6059</a>
                </p>
              </div>
              <hr/>
              <div>
                <h3>Escr&iacute;benos</h3>
                <p>
                  <Glyphicon glyph='envelope' /> <a href="mailto:contacto@pizarrovial.cl" target="_blank" rel="noopener noreferrer">contacto@pizarrovial.cl</a>
                </p>
                <p>
                  <Glyphicon glyph='envelope' /> <a href="mailto:licitacion@pizarrovial.cl" target="_blank" rel="noopener noreferrer">licitacion@pizarrovial.cl</a>
                </p>
              </div>
            </Col>
            <Col md={6}>
              <ContactForm />
            </Col>
          </Row>
          <Modal show={this.state.show} onHide={this.handleCloseMap} className="modalMap">
            <Modal.Header>
              <Modal.Title>Nuestra ubicaci&oacute;n</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <iframe title="Mapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3756.214922799447!2d-70.61882378831586!3d-33.393336173301314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c8ab8c44535f%3A0x46008b84c5585f81!2sDel%20Valle%20601%2C%208580678%20Huechuraba%2C%20Santiago%2C%20Regi%C3%B3n%20Metropolitana!5e1!3m2!1ses!2scl!4v1754424859409!5m2!1ses!2scl" width="600" height="450" style={{border: 0, allowFullScreen: "", loading: "lazy", referrerPolicy: "no-referrer-when-downgrade"}}></iframe>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleCloseMap}>Cerrar</Button>
            </Modal.Footer>
          </Modal>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Contact.js